export default __webpack_public_path__ + "static/media/SH.60194c80.svg";